require("./DropDown.less");

const React = require("react");

const QuestionType = require("~/types/Question.js").PropType;
const NewAnswerSelection = require("~/types/AnswerSelection.js").New;
const Comment = require("../Comment/Comment.jsx");
const Task = require("../Task/Task.jsx"); 

const DropDown = React.createClass({
    propTypes: {
        Question: QuestionType.isRequired,
        OnAnswerChange: React.PropTypes.func.isRequired
    },
    getInitialState() {
        const firstSelection = (this.props.Question.AnswerSelections || [])[0];

        if (firstSelection) {
            return {
                AnswerSelection: NewAnswerSelection(
                    firstSelection.SelectionText,
                    firstSelection.AdditionalComment,
                    firstSelection.GUID,
                    firstSelection.SelectionScoreValue),
                AdditionalComment: this.props.Question.AdditionalComment,
                Task: this.props.Question.Task
            }
        }
        else {
            return {
                AnswerSelection: NewAnswerSelection(),
                AdditionalComment: this.props.Question.AdditionalComment,
                Task: this.props.Question.Task
            };
        }
    },
    render() {
        const options = this.props.Question.AnswerOptions.sort((s1, s2) => {
            if (s1.DisplayOrder < s2.DisplayOrder) {
                return -1;
            }

            if (s1.DisplayOrder > s2.DisplayOrder) {
                return 1;
            }

            return 0;
        }).map(this.MakeOption);

        const showCommentField = this.props.Question.IncludeComment;

        const imgUrl = this.props.Question.ImageUrl; 

        return (<div className="cs-DropDown">
            <div className="cs-DropDown__flex-container">
                <header className="cs-DropDown__question"
                    dangerouslySetInnerHTML={{ __html: this.props.Question.DisplayHTML }} />
                <div>
                    {imgUrl && (<img style={{ width: 300 }} src={imgUrl} />)}
                </div>
                <div className="cs-DropDown__selection">
                    <select className="form-control cs-DropDown__dropdown" onChange={this.AnswerChanged}
                        value={this.state.AnswerSelection.SelectionText}>
                        <option value="">-- Please select --</option>
                        {options}
                    </select>
                </div>
            </div>
            <div className="cs-DropDown__selection--print">
                <label>Answer: </label><br />
                <b>{this.DisplayAnswer(this.state.AnswerSelection.SelectionText)}</b>
            </div>
            {showCommentField && (
                <Comment OnChange={this.OnCommentChange} Comment={this.state.AdditionalComment} />)}
            <Task OnChange={this.OnTaskChange} Task={this.state.Task}></Task>
        </div>);
    },
    MakeOption(answerOption) {
        return (<option key={answerOption.GUID}
                        value={answerOption.DisplayText}>{answerOption.DisplayText}
        </option>);
    },
    AnswerChanged(e) {
        let text = "";

        if (e) {
            text = e.target.value;
        }

        const answer = Object.assign({}, this.state.AnswerSelection, {
            SelectionText: text
        });

        this.props.OnAnswerChange([answer], this.state.AdditionalComment);

        this.setState({
            AnswerSelection: answer
        });
    },
    DisplayAnswer(answer) {
        if (answer === "") {
            return (<em>No answer entered</em>);
        }
        else {
            return answer;
        }
    },
    OnCommentChange(e) {
        this.props.OnAnswerChange([this.state.AnswerSelection], e.target.value, this.state.Task);

        this.setState({
            AdditionalComment: e.target.value
        });
    },
    OnTaskChange(e) {
        this.props.OnAnswerChange([this.state.AnswerSelection], this.state.AdditionalComment, e.target.value);

        this.setState({
            Task: e.target.value
        }); 
    }
});

module.exports = DropDown;


// WEBPACK FOOTER //
// ./src/components/DropDown/DropDown.jsx